/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Checklist item requirement: field value NOT IN list ({field} not in [{values}], eg docSubType not in [B1,B2,B1/B2])
 * @export
 * @interface PaxCheckFieldNotIn
 */
export interface PaxCheckFieldNotIn {
    /**
     * Requirement represented as text
     * @type {string}
     * @memberof PaxCheckFieldNotIn
     */
    asText: string;
    /**
     * Field
     * @type {string}
     * @memberof PaxCheckFieldNotIn
     */
    field: string;
    /**
     * Not allowed values
     * @type {Array<string>}
     * @memberof PaxCheckFieldNotIn
     */
    values: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFieldNotIn
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckFieldNotIn interface.
 */
export function instanceOfPaxCheckFieldNotIn(value: object): value is PaxCheckFieldNotIn {
    if (!('asText' in value) || value['asText'] === undefined) return false;
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFieldNotInFromJSON(json: any): PaxCheckFieldNotIn {
    return PaxCheckFieldNotInFromJSONTyped(json, false);
}

export function PaxCheckFieldNotInFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFieldNotIn {
    if (json == null) {
        return json;
    }
    return {
        
        'asText': json['as_text'],
        'field': json['field'],
        'values': json['values'],
        'type': json['type'],
    };
}

export function PaxCheckFieldNotInToJSON(json: any): PaxCheckFieldNotIn {
    return PaxCheckFieldNotInToJSONTyped(json, false);
}

export function PaxCheckFieldNotInToJSONTyped(value?: PaxCheckFieldNotIn | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'as_text': value['asText'],
        'field': value['field'],
        'values': value['values'],
        'type': value['type'],
    };
}

